import { createFileRoute } from '@tanstack/react-router';
import { DeepDivePage } from '@/features/debrief-v2';

export const Route = createFileRoute(
  '/_dashboard/interactions/debrief-v2/$id/deep-dive'
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <DeepDivePage sessionId={id} />;
}
